import React, { Component } from 'react';
import { Grid, Card, Dropdown } from 'semantic-ui-react';
import Loading from '../loading';
import $ from "jquery";
import _ from 'lodash';
import Server from '../../functions/server';
import Menucontrol from './menucontrol';

class Executive extends Component {

  state = {
    executiveOption: [],
    value: '',
    data: []
  }

  componentDidMount() {
    this.getExecutive();
  }

  getExecutive() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Executive!!!',
      menucontrol: false
    });
    let data1 = {};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'menucontrol/get.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          context.setExecutive(data);
          context.setState({
            data: data
          });
        } catch (e) {
          context.setState({
            load: false,
          });
        }

      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  setExecutive(data) {
    let context = this;
    var x = [];
    data.map((y) => {
      x.push({key: y.name, text: y.name, value: y.id+'->'+y.name});
    });
    try {
      context.setState({
        executiveOption: x,
      });
    } catch (e) {

    }
  }

  callChildMethod() {
    this.refs.child.appendsdata();
  }

  executive = (f, { value }) => {
    this.setState({ value: value, menucontrol: true })
    this.props.selectExecutive(value, this.state.data);
  }

  render() {
    let { load, message, value, menucontrol } = this.state;
    let loading, menucontrols;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    if (menucontrol) {
      menucontrols = (
        <div>
          <Menucontrol menuPermission={this.props.menuPermission} value={value} ref="child" newdata={this.props.newdata} />
        </div>
      )
    }
    return (
      <div style={{padding: '1%'}}>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <Card fluid style={{padding: '4%'}}>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={16}
                  style={{fontSize: 16, fontWeight: 'bold'}}>
                  Choose Executive
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Dropdown fluid placeholder=''
                    id="technology" onChange={this.executive}
                    search selection options={this.state.executiveOption}
                    value={value} fluid style={{ borderColor: '#5A9CBB' }} />
                </Grid.Column>
              </Grid>
              {menucontrols}
            </Card>
          </Grid.Column>
        </Grid>
        {loading}
      </div>
    );
  }
}

export default Executive;
